import { render, staticRenderFns } from "./carrelloInfoVoli.vue?vue&type=template&id=7669e846&"
import script from "./carrelloInfoVoli.vue.ts?vue&type=script&lang=ts&"
export * from "./carrelloInfoVoli.vue.ts?vue&type=script&lang=ts&"
import style0 from "./carrelloInfoVoli.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports